/* global ol */

var angular = require('angular');

function FullScreenControl(map) {
  this.map = map;
  this.closeOnEscape = this.closeOnEscape.bind(this);
  this.toggleFullScreen = this.toggleFullScreen.bind(this);
  this.control = this.initControl();
}

FullScreenControl.prototype.initControl = function() {
  var $div = angular.element(
    '<div class="ol-full-screen ol-unselectable ol-control"><button type="button" /></div>'
  );

  $div.find('button').on('click', this.toggleFullScreen);

  return new ol.control.Control({
    element: $div[0]
  });
};

FullScreenControl.prototype.toggleFullScreen = function() {
  var $body = angular.element(document.body);
  var $document = angular.element(document);

  if ($body.hasClass('map-full-screen')) {
    $body.removeClass('map-full-screen');
    $document.off('keydown', this.closeOnEscape);
  } else {
    $body.addClass('map-full-screen');
    $document.on('keydown', this.closeOnEscape);
  }

  this.map.updateSize();
};

FullScreenControl.prototype.closeOnEscape = function(event) {
  var toggleFullScreen = this.toggleFullScreen;

  if (event.keyCode !== 27) return;

  // Do not exit full-screen mode when using escape to close a modal
  setTimeout(function() {
    if (! event.isImmediatePropagationStopped()) {
      toggleFullScreen();
    }
  });
};

module.exports = FullScreenControl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/fullScreenControl.js
 ** module id = 178
 ** module chunks = 1
 **/